import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { initNewRelic } from 'shared/analytics/new-relic';
import bi from 'shared/bi/bi';
import applicationNames from 'shared/constants/application-names';
import { setupEnv } from 'shared/env/setup-env';
import { addSingleMeasurement } from 'shared/utils/performance';
import configureStore from 'widget/redux/configure-store';

import HomeLayout from './layouts/home/home';

bi.logWidgetSystem('mobile.app.initialized');

initNewRelic({
  application: applicationNames.WIDGET,
  layout: 'mobile',
});

addSingleMeasurement('appRenderStart');
setupEnv();

const store = configureStore({
  configuration: {
    applicationName: applicationNames.WIDGET,
  },
});

function render(HomeLayout) {
  ReactDOM.render(
    <ReduxProvider store={store}>
      <HomeLayout />
    </ReduxProvider>,
    document.getElementById('root')
  );
}

if (process.env.NODE_ENV === 'development') {
  import(/* webpackChunkName: "dev/dev-widget" */ 'dev/dev-widget')
    .then(() => render(HomeLayout));
} else {
  render(HomeLayout);
}

if (module.hot) {
  module.hot.accept('./layouts/home/home', () => {
    render(require('./layouts/home/home'));
  });
}



// WEBPACK FOOTER //
// ./src/mobile/mobile.js